import React, { useContext } from 'react';

import { Button, ButtonTheme } from '@imgly/imgly-website-components';

import { getVersion } from '../../../../utils/getVersion';
import { ReactComponent as CrossIcon } from '../../../assets/images/icons/Cross.svg';
import { ReactComponent as ExternalLink } from '../../../assets/images/icons/ExternalLink.svg';
import { NavigationContext } from '../../../context/NavigationContext';
import { PageContext } from '../../../context/PageContext';

import * as classes from './style.module.scss';

export const Title: React.FC = () => {
  const { version, versions, platform, product } = useContext(PageContext);
  const { closeNavigation } = useContext(NavigationContext);

  let link = null;

  if (version && versions?.some(({ id }) => id === version)) {
    const versionArgs = getVersion(version, versions);
    if (typeof versionArgs === 'object' && 'apiLink' in versionArgs) {
      link = versionArgs.apiLink;
    } else {
      link = `https://apidocs.img.ly/${product}/${
        platform ? `${platform}/` : ''
      }${version}/`;
    }
  }

  return (
    <div className={classes.root}>
      <Button
        className={classes.close}
        leadingIcon={<CrossIcon />}
        theme={ButtonTheme.Text}
        onClick={closeNavigation}
      />
      <span className={classes.text}>Documentation</span>
      {link && (
        <a
          target="_blank"
          rel="noreferrer noopener"
          className={classes.link}
          href={link}
          aria-label="Go to the API Documentation"
        >
          API <ExternalLink aria-hidden className={classes.icon} />
        </a>
      )}
    </div>
  );
};
